// extracted by mini-css-extract-plugin
export default {"Wrapper":"KAl816cvhCOyP34jgQyZ","Variant--wrapper":"DptV4VPqXGfjF0e5wN7f","Outer":"lpnXan5QohHunTRWN8e4","Inner":"EbO_uUsJjnT1L2k8lJFw"};